import { InventoryBulkPriceRepository } from '@lib/api/repository/inventory-bulk-price/inventory-bulk-price.repository';
import { BulkPriceUpdateAction, BulkPriceUpdateFilter } from '@lib/types';

export default class InventoryBulkPriceService {
  constructor(private repository: InventoryBulkPriceRepository) {}

  getBulkPricePreview(filters: BulkPriceUpdateFilter, action: BulkPriceUpdateAction) {
    return this.repository.getBulkPricePreview(filters, action);
  }

  applyBulkPriceUpdate(filters: BulkPriceUpdateFilter, action: BulkPriceUpdateAction) {
    return this.repository.applyBulkPriceUpdate(filters, action);
  }
}
